<script lang="ts" setup>
import desktopImage from '~/assets/images/chatbot/welcome_background.png';
import imageMobile from '~/assets/images/chatbot/welcome_mobile_background.png';

const { t } = useI18n();
const image = useImage();

const desktopImageProps = computed(() =>
  image.getSizes(desktopImage, {
    modifiers: { format: 'webp' },
    sizes: IMAGE_SIZES.halfScreen,
  }),
);
const mobileImageProps = computed(() =>
  image.getSizes(imageMobile, {
    modifiers: { format: 'webp' },
    sizes: IMAGE_SIZES.fullscreen,
  }),
);
</script>

<template>
  <section class="sectionChatbotWelcome">
    <picture class="sectionChatbotWelcome__image">
      <source v-bind="desktopImageProps" media="(min-width: 768px)" />
      <img :alt="t('alt')" v-bind="mobileImageProps" />
    </picture>
    <SvgoLogoFull :font-controlled="false" filled class="sectionChatbotWelcome__logo" />

    <h1 class="sectionChatbotWelcome__title">{{ t('title') }}</h1>
    <BaseButton
      to="https://t.me/beautyfailbot"
      size="s"
      mobile-size="xxs"
      rectangle
      outlined
      primary-color="#C5299B"
      class="sectionChatbotWelcome__action"
    >
      {{ t('action') }}
    </BaseButton>
  </section>
</template>

<i18n>
ru:
  title: Бьюти-фейлы, которые достойны iPhone
  action: Рассказать
  alt: Коллаж из эмодзи и сообщений, иллюстрирующий шутливую ситуацию с неудачным окрашиванием волос и сообщением о возможности выиграть iPhone.

en:
  title: Beauty fails worthy of an iPhone
  action: Share your story
  alt: A collage of emojis and messages illustrating a humorous hair-coloring fail and a notification about a chance to win an iPhone.
</i18n>

<style lang="scss">
.sectionChatbotWelcome {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: calc(100svh - 80px);
  padding: 55px 50px 45px;
  overflow: hidden;

  @include mq('sm') {
    min-height: calc(100svh - 40px);
    padding: 17px 16px 70px;
  }

  &::before {
    content: '';
    position: absolute;
    top: -18%;
    bottom: -10%;
    left: -1.4%;
    right: -1.8%;
    background: linear-gradient(44.66deg, #ffdffb 37.69%, #c5299b 147.89%);

    @include mq('sm') {
      top: -3%;
      bottom: -4%;
      left: -11%;
      right: -9%;
      background: linear-gradient(-45.34deg, #ffdffb 37.69%, #c5299b 147.89%);
    }
  }

  & > * {
    position: relative;
  }

  &__logo {
    width: 165px;
    height: 172px;
    color: #c5299b;
    margin-bottom: 50px;

    @include mq('sm') {
      width: 121px;
      height: 126px;
    }
  }

  &__image {
    position: absolute;
    width: 50%;
    top: 50%;
    translate: 0 -50%;
    right: 8%;

    @include mq('sm') {
      width: 89%;
      max-width: 540px;
      top: 43%;
      right: 54%;
      translate: 50% -50%;
    }

    img {
      width: 100%;
      display: block;
    }
  }

  &__title {
    max-width: 435px;
    font-variation-settings: 'wght' 700;
    font-size: 53px;
    line-height: 59px;
    letter-spacing: 1px;
    color: #c5299b;
    margin-top: auto;
    margin-bottom: 38px;

    @include mq('sm') {
      max-width: 285px;
      font-size: 23px;
      line-height: 25px;
      margin-bottom: 26px;
    }
  }

  &__action {
    width: 439px;
    max-width: 100%;

    @include mq('sm') {
      width: 255px;
    }
  }
}
</style>
